'use client';

import { useEffect, useRef } from 'react';
import Clarity from '@microsoft/clarity';

export function ClarityProvider() {
  const hasInitialized = useRef(false);

  useEffect(() => {
    const projectId = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID?.trim();
    const isProduction = process.env.NODE_ENV === 'production';

    if (!isProduction || !projectId || hasInitialized.current) {
      return;
    }

    Clarity.init(projectId);
    hasInitialized.current = true;
  }, []);

  return null;
}
